import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserProfile,
  saveUser,
  deleteUser
} from "../../redux/actions/userActions";
import { useAuth0 } from "@auth0/auth0-react";
import "./Profile.scss";

export default function UserPage() {
  const userFromState = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [updatedUser, setUpdatedUser] = useState(userFromState);
  const [isUserChanged, setIsUserChanged] = useState(false);
  const { user, getAccessTokenSilently, logout } = useAuth0();

  if (!user) {
    console.log("no user");
    return null;
  }

  useEffect(() => {
    if (!userFromState.id) {
      getUser();
    } else {
      console.log(userFromState);
    }
  }, [user]);

  const getUser = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const data = await dispatch(getUserProfile(accessToken));
      console.log(data);
      setUpdatedUser(data);
    } catch (error) {
      console.log(error);
    }
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setUpdatedUser(prevUser => ({
      ...prevUser,
      [name]: value
    }));
    setIsUserChanged(true);
  }

  function handleSave(e) {
    e.preventDefault();
    console.log(updatedUser);
    if (isUserChanged) {
      saveUserProfile();
      setIsUserChanged(false);
    }
  }

  const saveUserProfile = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const data = await dispatch(saveUser(accessToken, updatedUser));
      console.log(data);
      setUpdatedUser(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async e => {
    e.preventDefault();
    if (
      window.confirm(`Vill du radera din profil?
    OBS: Händelserna som du lagt till kommer också försvinna.`)
    ) {
      console.log("delete user : ", user.sub);
      await deleteUserProfile();
      await handleLogout();
      setUpdatedUser({});
      setIsUserChanged(false);
    } else {
      console.log("cancel");
    }
  };

  const deleteUserProfile = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      await dispatch(deleteUser(accessToken));
    } catch (error) {
      console.log(error);
    }
  };

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  return (
    <form className="profile" onSubmit={handleSave}>
      <div className="profile-name">
        <span className="label">Profilnamn: </span>
        <input
          className="input-name"
          type="text"
          name="name"
          defaultValue={updatedUser.name}
          onChange={handleChange}
        />
      </div>
      <div className="profile-city">
        <span className="label">Min stad: </span>
        <input
          className="input-city"
          type="text"
          name="city"
          defaultValue={updatedUser.city}
          onChange={handleChange}
        />
      </div>
      <span className="description-label">Beskrivning: </span>
      <textarea
        className="profile-description"
        name="description"
        defaultValue={updatedUser.description}
        placeholder="Beskriv dig själv hur du vill, men tänk på att det du skriver här är synligt för alla."
        maxLength="500"
        onChange={handleChange}
      />
      <div className="line"></div>
      <div className="actions">
        {isUserChanged && (
          <button className="edit" type="submit">
            Spara ändringar
          </button>
        )}
        <input
          className="button"
          type="submit"
          onClick={handleDelete}
          value="Ta bort profil"
        />
      </div>
    </form>
  );
}
